module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/e587d9d7e9a2f1f28041ba5c15db7a40.svg";